import { Button, Modal } from 'react-bootstrap';
import { LuBriefcase } from 'react-icons/lu';

import SbrIcon from './SbrIcon';

type Props = {
  show: boolean;
  onHide: () => void;
};

export default function CareersNoticeModal({ show, onHide }: Props) {
  return (
    <Modal show={show} onHide={onHide} centered className="careers-notice-modal">
      <Modal.Header closeButton className="careers-notice-modal__header border-0 pb-0">
        <Modal.Title className="visually-hidden">Careers at SBR2TH</Modal.Title>
      </Modal.Header>
      <Modal.Body className="careers-notice-modal__body text-center pt-2 pb-4 px-4">
        <div className="careers-notice-modal__icon" aria-hidden>
          <SbrIcon icon={LuBriefcase} size={28} />
        </div>
        <h2 className="careers-notice-modal__title fw-bold mb-2">No Open Roles Right Now</h2>
        <p className="careers-notice-modal__text mb-4">
          We don&apos;t have any new opportunities at the moment. Please check back soon—we&apos;re always growing.
        </p>
        <Button variant="secondary" className="fw-semibold px-4" onClick={onHide}>
          Got it
        </Button>
      </Modal.Body>
    </Modal>
  );
}
